









import Vue from "vue";
import ModlistCard from "../mods/ModlistCard.vue";
import Event from "@/classes/Event";

export default Vue.extend({
  components: {
    ModlistCard,
  },
  props: {
    event: {
      type: Object as () => Event,
      required: true,
    },
  },
});
